import script from "./client-policy.vue?vue&type=script&lang=ts&setup=true"
export * from "./client-policy.vue?vue&type=script&lang=ts&setup=true"

import "./client-policy.vue?vue&type=style&index=0&id=f05a3554&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f05a3554"]])

export default __exports__